import "./MonthPanel.scss";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const MonthPanel = ({
  startDate,
  year,
  selected,
  onSelect,
  from,
  to,
  calendarType,
  onYearChange,
  className,
}) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth(); // 0-based
  const currentYear = currentDate.getFullYear();
  const start = new Date(startDate.year, startDate.month);
  const today = new Date(); // or use endDate if needed

  return (
    <div className={`month-panel border-end ${className}`}>
      <div className="month-panel-header">
        <button
          className="btn"
          onClick={() => onYearChange(year - 1)}
          disabled={
            year === startDate.year ||
            (calendarType === "TO" && from.year === to.year)
          }
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <span>{year}</span>
        <button
          className="btn"
          onClick={() => onYearChange(year + 1)}
          disabled={
            year === currentYear ||
            (calendarType === "FROM" && from.year === to.year)
          }
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>

      <div className="month-grid">
        {months.map((m, idx) => {
          const selectedDate = new Date(year, idx);

          // --- 1. TO Calendar Logic: Disable months BEFORE the 'from' date ---
          const isBeforeFrom =
            calendarType === "TO" &&
            (year < from.year || (year === from.year && idx < from.month));

          // --- 2. FROM Calendar Logic: Disable months AFTER the 'to' date ---
          const isAfterTo =
            calendarType === "FROM" &&
            (year > to.year || (year === to.year && idx > to.month));

          // --- 3. General Boundaries (Start of History & Today) ---
          const isOutOfBounds =
            (year === startDate.year && idx < startDate.month) ||
            (year === currentYear && idx > currentMonth);

          // Combine all disabling factors
          const isDisabled = isBeforeFrom || isAfterTo || isOutOfBounds;

          return (
            <div
              key={m}
              className={`month-cell ${isDisabled ? "disabled" : ""} ${
                selected.month === idx && selected.year === year
                  ? "selected"
                  : ""
              }`}
              onClick={() => {
                if (!isDisabled) {
                  onSelect(idx);
                }
              }}
            >
              {m}
            </div>
            // <div
            //   key={m}
            //   className={`month-cell ${year > startDate.year ? "" : idx < startDate.month ? "disabled" : ""} ${year < currentYear ? "" : idx > currentMonth ? "disabled" : ""} ${
            //     selected.month === idx && selected.year === year
            //       ? "selected"
            //       : ""
            //   }`}
            //   onClick={() => {
            //     if (selectedDate >= start && selectedDate <= today) {
            //       onSelect(idx);
            //     }
            //   }}
            // >
            //   {m}
            // </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthPanel;
